export default "__VITE_ASSET__Da8zSu9N__"